// Module
var code = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <h1>地区を選択する</h1>\n    </div>\n  </div>\n</div>\n";
// Exports
export default code;